// リスト処理化用
export const DATA_CLASSIFICATION_LIST = [
  { code: 99, name: "指定しない", enumname: "All" },
  { code: 1, name: "確定申告", enumname: "Final" },
  { code: 2, name: "修正申告", enumname: "Amended" },
  { code: 3, name: "予定申告", enumname: "Provisional" },
  { code: 4, name: "中間申告", enumname: "Interim" },
  { code: 5, name: "見込納付", enumname: "Estimated" },
  { code: 6, name: "四半期試算", enumname: "Quarterly" },
  { code: 38, name: "新規", enumname: "New" },
  { code: 39, name: "追加", enumname: "Addition" },
  { code: 40, name: "訂正", enumname: "Correction" },
  { code: 41, name: "無効(取消)", enumname: "Invalid" },
  { code: 0, name: "区分なし", enumname: "None" },
];

export const DATA_CLASSIFICATION_DETAIL = [
  { code: 0, name: "-", enumname: "None" },
  { code: 1, name: "確定申告", enumname: "Final" },
  { code: 2, name: "修正申告", enumname: "Amended" },
  { code: 3, name: "予定申告", enumname: "Provisional" },
  { code: 4, name: "中間申告", enumname: "Interim" },
  { code: 5, name: "見込納付", enumname: "Estimated" },
  {
    code: 6,
    name: "四半期試算(1/4)",
    enumname: "Quarterly1",
  },
  {
    code: 7,
    name: "四半期試算(2/4)",
    enumname: "Quarterly2",
  },
  {
    code: 8,
    name: "四半期試算(3/4)",
    enumname: "Quarterly3",
  },
  {
    code: 9,
    name: "四半期試算(4/4)",
    enumname: "Quarterly4",
  },
  {
    code: 10,
    name: "予定申告(1/3)",
    enumname: "Provisional1_3",
  },
  {
    code: 11,
    name: "予定申告(2/3)",
    enumname: "Provisional2_3",
  },
  {
    code: 12,
    name: "予定申告(3/3)",
    enumname: "Provisional3_3",
  },
  {
    code: 13,
    name: "予定申告(1/11)",
    enumname: "Provisional1_11",
  },
  {
    code: 14,
    name: "予定申告(2/11)",
    enumname: "Provisional2_11",
  },
  {
    code: 15,
    name: "予定申告(3/11)",
    enumname: "Provisional3_11",
  },
  {
    code: 16,
    name: "予定申告(4/11)",
    enumname: "Provisional4_11",
  },
  {
    code: 17,
    name: "予定申告(5/11)",
    enumname: "Provisional5_11",
  },
  {
    code: 18,
    name: "予定申告(6/11)",
    enumname: "Provisional6_11",
  },
  {
    code: 19,
    name: "予定申告(7/11)",
    enumname: "Provisional7_11",
  },
  {
    code: 20,
    name: "予定申告(8/11)",
    enumname: "Provisional8_11",
  },
  {
    code: 21,
    name: "予定申告(9/11)",
    enumname: "Provisional9_11",
  },
  {
    code: 22,
    name: "予定申告(10/11)",
    enumname: "Provisional10_11",
  },
  {
    code: 23,
    name: "予定申告(11/11)",
    enumname: "Provisional11_11",
  },
  {
    code: 24,
    name: "中間申告(1/3)",
    enumname: "Interim1_3",
  },
  {
    code: 25,
    name: "中間申告(2/3)",
    enumname: "Interim2_3",
  },
  {
    code: 26,
    name: "中間申告(3/3)",
    enumname: "Interim3_3",
  },
  {
    code: 27,
    name: "中間申告(1/11)",
    enumname: "Interim1_11",
  },
  {
    code: 28,
    name: "中間申告(2/11)",
    enumname: "Interim2_11",
  },
  {
    code: 29,
    name: "中間申告(3/11)",
    enumname: "Interim3_11",
  },
  {
    code: 30,
    name: "中間申告(4/11)",
    enumname: "Interim4_11",
  },
  {
    code: 31,
    name: "中間申告(5/11)",
    enumname: "Interim5_11",
  },
  {
    code: 32,
    name: "中間申告(6/11)",
    enumname: "Interim6_11",
  },
  {
    code: 33,
    name: "中間申告(7/11)",
    enumname: "Interim7_11",
  },
  {
    code: 34,
    name: "中間申告(8/11)",
    enumname: "Interim8_11",
  },
  {
    code: 35,
    name: "中間申告(9/11)",
    enumname: "Interim9_11",
  },
  {
    code: 36,
    name: "中間申告(10/11)",
    enumname: "Interim10_11",
  },
  {
    code: 37,
    name: "中間申告(11/11)",
    enumname: "Interim11_11",
  },
  { code: 38, name: "新規", enumname: "New" },
  { code: 39, name: "追加", enumname: "Addition" },
  { code: 40, name: "訂正", enumname: "Correction" },
  { code: 41, name: "無効(取消)", enumname: "Invalid" },
];

export const FISCAL_YEAR_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "指定日以前" },
  { code: 2, name: "指定日" },
  { code: 3, name: "指定日以降" },
];

export const YEAR_LIST = [
  { code: 0, name: "令和" },
  { code: 1, name: "平成" },
];

export const WAREKI_YEAR_LIST = [
  { code: 0, name: "" },
  { code: 1, name: "令和" },
  { code: 2, name: "平成" },
  { code: 3, name: "昭和" },
  { code: 4, name: "大正" },
  { code: 5, name: "明治" },
];

export const DATA_NAME_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "未入力" },
  { code: 2, name: "右記から始まる" },
  { code: 3, name: "右記を含む" },
  { code: 4, name: "右記を含まない" },
];

export const BUSINESS_DATA_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "右記から始まる" },
  { code: 2, name: "右記を含む" },
  { code: 3, name: "右記を含まない" },
];

export const MONTH_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "1月" },
  { code: 2, name: "2月" },
  { code: 3, name: "3月" },
  { code: 4, name: "4月" },
  { code: 5, name: "5月" },
  { code: 6, name: "6月" },
  { code: 7, name: "7月" },
  { code: 8, name: "8月" },
  { code: 9, name: "9月" },
  { code: 10, name: "10月" },
  { code: 11, name: "11月" },
  { code: 12, name: "12月" },
];

export const CORPORATION_DIVISION_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "法人" },
  { code: 2, name: "個人" },
];

export const NOTICE_DIVISION_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "する" },
  { code: 2, name: "しない" },
];

export const EDIT_DIVISION_LIST = [
  { code: 0, name: "指定しない" },
  { code: 2, name: "しない" },
  { code: 1, name: "する" },
];

export const HAS_HASNOT_LIST = [
  { code: 2, name: "指定しない" },
  { code: 1, name: "有り" },
  { code: 0, name: "無し" },
];

export const WITH_WITHOUT_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "発行済" },
  { code: 2, name: "未発行" },
];

export const WITH_WITHOUT_EMAIL_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "設定済" },
  { code: 2, name: "未設定" },
];

export const DETAIL_DURING_DATE_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "指定期間" },
  { code: 2, name: "指定日" },
];

export const DETAIL_BLANK_PERMISSION_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "未入力" },
  { code: 2, name: "右記から始まる" },
  { code: 3, name: "右記を含む" },
  { code: 4, name: "右記を含まない" },
];

export const DETAIL_BLANK_NONPERMISSION_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "右記から始まる" },
  { code: 2, name: "右記を含む" },
  { code: 3, name: "右記を含まない" },
];

export const DOCUMENT_STATUS_LIST = [
  { code: 99, name: "指定しない", value1: "" },
  { code: 1, name: "未収集", value1: "Unrequested" },
  {
    code: 2,
    name: "依頼済",
    value1: "Requested",
    value2: "Waiting",
    value3: "AnyCollected",
  },
  { code: 5, name: "収集済", value1: "Collected", value2: "NotSubmit" },
  {
    code: 7,
    name: "再依頼",
    value1: "ReRequested",
    value2: "ReWaiting",
    value3: "ReAnyCollected",
  },
  { code: 10, name: "確認済", value1: "Checked" },
  { code: 0, name: "収集状況なし", value1: "" },
];
//配信状況(年末調整)
export const DELIVERY_STATUS_LIST = [
  { code: 99, name: "指定しない", value1: "" },
  { code: 1, name: "未配信", value1: "Undelivered" },
  {
    code: 2,
    name: "配信済",
    value1: "Delivered",
  },
  { code: 3, name: "受取確認済", value1: "ConfirmedReceipt" },
  {
    code: 0,
    name: "配信状況なし",
    value1: "NoDeliveryStatus",
  },
];

//
// 概要:
//     配信書類ステータスを表します。
export const TZCR_DISTRIBUTION_DOCUMENT_STATUS =
[
  { code: 99, name: "指定しない", value1: "" },
  { code: 1, name: "未配信", value1: "Undistributed" },
  { code: 2, name: "配信済", value1: "Distributed" },
  { code: 3, name: "受取確認済", value1: "Checked" },
]
export const DOCUMENT_STATUS_YEAREND_LIST = [
  { code: 99, name: "指定しない", value1: "" },
  { code: 1, name: "未収集", value1: "Unrequested" },
  {
    code: 2,
    name: "依頼済",
    value: "Requested",
  },
  { code: 3, name: "収集済", value: "Collected" },
  {
    code: 4,
    name: "差戻し",
    value: "Remand",
  },
  { code: 5, name: "確認済", value1: "Checked" },
  { code: 6, name: "期限切れ", value1: "Expired" },
  { code: 0, name: "収集状況なし", value1: "" },
];

export const DOCUMENT_COLLECTMODE_LIST = [
  { code: 0, name: "指定しない", value: "None" },
  { code: 1, name: "オンライン", value: "Web" },
  { code: 2, name: "書面", value: "Paper" },
  { code: 3, name: "対象外", value: "NotCollect" },
];
export const FORMAT_MODE_LIST = [
  { code: 4, name: "あり" },
  { code: 1, name: "なし" },
];

export const CHANGE_DOCUMENT_STATUS_LIST = [
  { code: 0, name: "「収集済」に変更する", value: "収集済" },
  { code: 1, name: "「収集済」を解除する", value: "収集済" },
  { code: 2, name: "「確認済」に変更する", value: "確認済" },
  { code: 3, name: "「確認済」を解除する", value: "確認済" },
];

export const CHANGE_DOCUMENT_STATUS_YEAREND_LIST = [
  { code: 0, name: "「依頼済」を解除する", value: "依頼済" },
  { code: 1, name: "「収集済」に変更する", value: "収集済" },
  // 23/09/04 仕様変更により「収集済」を解除する 機能が不要となる（IT2_No205）
  //{ code: 2, name: "「収集済」を解除する", value: "未収集" },
  { code: 3, name: "「確認済」に変更する", value: "確認済" },
  { code: 4, name: "「確認済」を解除する", value: "収集済" },
];

export const NOTIFICATION_STATUS_LIST = [
  { code: 99, name: "指定しない" },
  { code: 0, name: "未通知" },
  { code: 1, name: "通知済(メール)" },
  { code: 2, name: "通知済(Excel)" },
];

export const EMP_NOTIFICATION_STATUS_LIST = [
  { code: 99, name: "指定しない" },
  { code: 0, name: "未通知" },
  { code: 1, name: "通知済(メール)" },
  { code: 2, name: "通知済(ファイル)" },
];

export const DOCUMENT_STATUS = [
  { code: 0, name: "「確認済」に変更する", value: "Checked" },
  { code: 1, name: "「確認済」を解除する", value: "Collected" },
];

export const BLOB_TIME_STATUSLIST = [
  { code: 0, name: "事業年度", value1: "事業年度(自)", value2: "事業年度(至)" },
  { code: 1, name: "事業年度", value1: "事業年度(自)", value2: "事業年度(至)" },
  { code: 2, name: "事業年度", value1: "事業年度(自)", value2: "事業年度(至)" },
  { code: 3, name: "事業年度", value1: "事業年度(自)", value2: "事業年度(至)" },
  {
    code: 4,
    name: "申告年度",
    value1: "申告年度の1/1",
    value2: "申告年度の12/31",
  },
  {
    code: 5,
    name: "申告年度",
    value1: "申告年度の1/1",
    value2: "申告年度の12/31",
  },
  {
    code: 6,
    name: "申告年度",
    value1: "申告年度の1/1",
    value2: "申告年度の12/31",
  },
  { code: 7, name: "事業年度", value1: "事業年度(自)", value2: "事業年度(至)" },
  {
    code: 8,
    name: "申告年度",
    value1: "申告年度の1/1",
    value2: "申告年度の12/31",
  },
  { code: 9, name: "課税期間", value1: "課税期間(自)", value2: "課税期間(至)" },
  {
    code: 10,
    name: "課税期間",
    value1: "課税期間(自)",
    value2: "課税期間(至)",
  },
  {
    code: 11,
    name: "申告年度",
    value1: "申告年度の1/1",
    value2: "申告年度の12/31",
  },
  {
    code: 12,
    name: "申告年度",
    value1: "申告年度の1/1",
    value2: "申告年度の12/31",
  },
  {
    code: 13,
    name: "申告年度",
    value1: "申告年度の1/1",
    value2: "申告年度の12/31",
  },
  {
    code: 14,
    name: "申告年度",
    value1: "申告年度の1/1",
    value2: "申告年度の12/31",
  },
  {
    code: 15,
    name: "申告年度",
    value1: "申告年度の1/1",
    value2: "申告年度の12/31",
  },
  {
    code: 16,
    name: "申告年度",
    value1: "申告年度の1/1",
    value2: "申告年度の12/31",
  },
  {
    code: 17,
    name: "申告年度",
    value1: "申告年度の1/1",
    value2: "申告年度の12/31",
  },
  {
    code: 18,
    name: "申告年度",
    value1: "申告年度の1/1",
    value2: "申告年度の12/31",
  },
  {
    code: 19,
    name: "対象年度",
    value1: "対象年度の1/1",
    value2: "対象年度の12/31",
  },
  {
    code: 20,
    name: "適用年度",
    value1: "適用年度の1/1",
    value2: "適用年度の12/31",
  },
  {
    code: 21,
    name: "申告年度",
    value1: "申告年度の1/1",
    value2: "申告年度の12/31",
  },
  {
    code: 22,
    name: "適用年度",
    value1: "適用年度の1/1",
    value2: "適用年度の12/31",
  },
  {
    code: 23,
    name: "対象年度",
    value1: "対象年度の1/1",
    value2: "対象年度の12/31",
  },
  {
    code: 24,
    name: "対象年度",
    value1: "対象年度の1/1",
    value2: "対象年度の12/31",
  },
  {
    code: 25,
    name: "事業年度",
    value1: "事業年度(自)",
    value2: "事業年度(至)",
  },
  {
    code: 26,
    name: "申告年度",
    value1: "申告年度の1/1",
    value2: "申告年度の12/31",
  },
  {
    code: 27,
    name: "事業年度",
    value1: "事業年度(自)",
    value2: "事業年度(至)",
  },
  {
    code: 28,
    name: "申告年度",
    value1: "申告年度の1/1",
    value2: "申告年度の12/31",
  },
];

export const TAXNAME_TO_CODE_MAP = new Map([
  ["法人税申告書", 0],
  ["法人税申告書(グループ通算用)", 1],
  ["内訳概況書", 2],
  ["固定資産台帳", 3],
  ["固定資産台帳", 4],
  ["償却資産申告書", 5],
  ["償却資産申告書", 6],
  ["法人税別表十六", 7],
  ["所得税青色申告決算書別表", 8],
  ["消費税申告書", 9],
  ["消費税申告書", 10],
  ["所得税申告書及び財産債務調書等", 11],
  ["給与所得の源泉徴収票等の法定調書合計表・給与支払報告書等", 12],
  ["給与所得の源泉徴収票等の法定調書合計表・給与支払報告書等", 13],
  ["配当等の分配等の支払調書合計表等", 14],
  ["配当等の分配等の支払調書合計表等", 15],
  ["非居住者等に支払われる給与等の支払調書合計表等", 16],
  ["非居住者等に支払われる給与等の支払調書合計表等", 17],
  ["相続税申告書", 18],
  ["相続シミュレーション", 19],
  ["事業承継税制提出書類", 20],
  ["贈与税申告書", 21],
  ["事業承継税制提出書類", 22],
  ["財産評価明細書", 23],
  ["財産評価明細書", 24],
  ["事業所税申告書", 25],
  ["事業所税申告書", 26],
  ["貸付状況等申告書", 27],
  ["貸付状況等申告書", 28],
]);

export const DOCUMENT_STATSU_STRING_MAP = [
  ["None", 0],
  ["Unrequested", 1],
  ["Requested", 2],
  ["Waiting", 3],
  ["AnyCollected", 4],
  ["Collected", 5],
  ["NotSubmit", 6],
  ["ReRequested", 7],
  ["ReWaiting", 8],
  ["ReAnyCollected", 9],
  ["Checked", 10],
];

export const DATA_USAGE = [
  [0, 1023, " B"],
  [1024, 1048575, " KB"],
  [1048576, 1073741823, " MB"],
  [1073741824, 1099511627775, " GB"],
  [1099511627776, 999999999999999, " TB"],
  // [1000000000000000, 999999999999999999, ' PB'],
  // [1000000000000000000, , ' EB']
];

export const COLLECTION_STATUS = [
  ["未収集", "label_request_m1.png"],
  ["依頼済", "label_request_m2.png"],
  ["依頼済(書類提出待)", "label_request2-2.png"],
  ["依頼済(一部提出済)", "label_request2-3.png"],
  ["収集済", "label_request_m3.png"],
  ["収集済(提出無し)", "label_request3-2.png"],
  ["再依頼", "label_request_m4.png"],
  ["再依頼(書類提出待)", "label_request4-2.png"],
  ["再依頼(一部提出済)", "label_request4-3.png"],
  ["確認済", "label_request_m5.png"],
];

export const BUSINESS_DOCUMENT_STATUS = [
  { code: 2, name: "未提出" },
  { code: 3, name: "書面提出" },
  { code: 4, name: "一部提出済" },
  { code: 5, name: "提出済" },
  { code: 6, name: "提出無し" },
  { code: 7, name: "再提出" },
  { code: 8, name: "書面提出" },
  { code: 9, name: "一部提出済" },
  { code: 10, name: "確認済" },
];

export const SUBMISSION_DOCUMENT_CLASSIFICATION = [
  { code: 0, name: "通常" },
  { code: 1, name: "無し" },
  { code: 2, name: "書面" },
];

export const DISPLAY_FLAG_LIST = [
  {
    code: 101,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      BusinessFiscal: true,
      InheritanceStartDate: false,
      CalculationBaseDate: false,
      TaxYear: false,
      BusinessYear: false,
      FiscalYear: false,
      TaxPeriod: false,
      DataClassification: [1, 2, 3, 4, 5, 6],
      CalculationPeriod: true,
    },
  },
  {
    code: 102,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      BusinessFiscal: true,
      InheritanceStartDate: false,
      CalculationBaseDate: false,
      TaxYear: false,
      BusinessYear: false,
      FiscalYear: false,
      TaxPeriod: false,
      DataClassification: [1, 2, 3, 4, 5, 6],
      CalculationPeriod: true,
    },
  },
  {
    code: 103,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      BusinessFiscal: true,
      InheritanceStartDate: false,
      CalculationBaseDate: false,
      TaxYear: false,
      BusinessYear: false,
      FiscalYear: false,
      TaxPeriod: false,
      DataClassification: [1, 4],
      CalculationPeriod: false,
    },
  },
  {
    code: 201,
    BusinessOperatorType: "LegalEntity",
    DisplayFlags: {
      BusinessFiscal: true,
      InheritanceStartDate: false,
      CalculationBaseDate: false,
      TaxYear: false,
      BusinessYear: false,
      FiscalYear: false,
      TaxPeriod: false,
      DataClassification: [],
      CalculationPeriod: false,
    },
  },
  {
    code: 201,
    BusinessOperatorType: "Individual",
    DisplayFlags: {
      BusinessFiscal: false,
      InheritanceStartDate: false,
      CalculationBaseDate: false,
      TaxYear: true,
      BusinessYear: false,
      FiscalYear: false,
      TaxPeriod: false,
      DataClassification: [],
      CalculationPeriod: false,
    },
  },
  {
    code: 202,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      TaxYear: true,
      DataClassification: [1, 2],
    },
  },
  {
    code: 203,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      BusinessFiscal: true,
      DataClassification: [1, 2, 4, 5, 6],
      CalculationPeriod: true,
    },
  },
  {
    code: 204,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      TaxYear: true,
      DataClassification: [1, 2],
      CalculationPeriod: false,
    },
  },
  {
    code: 301,
    BusinessOperatorType: "LegalEntity",
    DisplayFlags: {
      BusinessFiscal: true,
      TaxPeriod: true,
      DataClassification: [1, 2, 3, 4, 5],
      CalculationPeriod: true,
    },
  },
  {
    code: 301,
    BusinessOperatorType: "Individual",
    DisplayFlags: {
      TaxYear: true,
      TaxPeriod: true,
      DataClassification: [1, 2, 3, 4],
      CalculationPeriod: true,
    },
  },
  {
    code: 401,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      TaxYear: true,
      DataClassification: [1, 2],
    },
  },
  {
    code: 501,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      TaxYear: true,
      DataClassification: [38, 39, 40, 41],
    },
  },
  {
    code: 502,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      TaxYear: true,
      DataClassification: [38, 39, 40, 41],
    },
  },
  {
    code: 503,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      TaxYear: true,
      DataClassification: [38, 39, 40, 41],
    },
  },
  {
    code: 601,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      InheritanceStartDate: true,
      TaxYear: true,
      DataClassification: [1, 2],
    },
  },
  {
    code: 602,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      BusinessYear: true,
      DataClassification: [],
    },
  },
  {
    code: 603,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      FiscalYear: true,
      DataClassification: [],
    },
  },
  {
    code: 604,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      TaxYear: true,
      DataClassification: [1, 2],
    },
  },
  {
    code: 605,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      FiscalYear: true,
      DataClassification: [],
    },
  },
  {
    code: 701,
    BusinessOperatorType: "Both",
    DisplayFlags: {
      CalculationBaseDate: true,
      BusinessYear: true,
      DataClassification: [],
    },
  },
  {
    code: 801,
    BusinessOperatorType: "LegalEntity",
    DisplayFlags: {
      BusinessFiscal: true,
      DataClassification: [1, 2],
    },
  },
  {
    code: 801,
    BusinessOperatorType: "Individual",
    DisplayFlags: {
      TaxYear: true,
      DataClassification: [1, 2],
    },
  },
  {
    code: 802,
    BusinessOperatorType: "LegalEntity",
    DisplayFlags: {
      BusinessFiscal: true,
      DataClassification: [],
    },
  },
  {
    code: 802,
    BusinessOperatorType: "Individual",
    DisplayFlags: {
      TaxYear: true,
      DataClassification: [],
    },
  },
];

export const PAYMENT_FREQUENCY_LIST = [
  { code: 1, name: "年1回" },
  { code: 3, name: "年3回" },
  { code: 11, name: "年11回" },
];

export const PAYMENT_TIME_LIST = [
  { code: 1, name: "1回目" },
  { code: 2, name: "2回目" },
  { code: 3, name: "3回目" },
  { code: 4, name: "4回目" },
  { code: 5, name: "5回目" },
  { code: 6, name: "6回目" },
  { code: 7, name: "7回目" },
  { code: 8, name: "8回目" },
  { code: 9, name: "9回目" },
  { code: 10, name: "10回目" },
  { code: 11, name: "11回目" },
];

// **********************************************
// システム閉塞種別
// **********************************************
export const SYSTEM_CLOSE_TYPE = {
  SystemClosedTime: "システム閉塞時間",
  MaintenanceTime: "メンテナンス時間",
};

// **********************************************
// 登録できないファイルの拡張子を設定
// **********************************************
export const CHECK_FILE_SUFFIX = ["html", "htm"];

//#region DC01C09_絞り込み条件設定画面
export const DETAIL_BUSINESS_CODE_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "次のキーワードを含む" },
  { code: 2, name: "次のキーワードを含まない" },
  { code: 100, name: "未設定" },
];

export const DETAIL_DESIGNATED_DATE_LIST = [
  { code: 0, name: "指定しない" },
  { code: 2, name: "指定日" },
  { code: 3, name: "指定月" },
  { code: 1, name: "指定期間" },
];
export const BUSINESS_FUNCTION_RELEASE_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "あり" },
  { code: 2, name: "なし" },
];

export const NOTIFICATION_DESTINATION_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "設定済" },
  { code: 2, name: "未設定" },
];

export const BUSINESS_ACCOUNT_LIST = [
  { code: 0, name: "指定しない" },
  { code: 2, name: "未発行" },
  { code: 1, name: "発行済" },
];

export const DETAIL_DECLARATION_YEAR_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "指定年" },
  { code: 2, name: "指定期間" },
];

export const PROCESSING_TYPE_LIST = [
  { code: 99, name: "指定しない", enumname: "All" },
  { code: 1, name: "ログイン", enumname: "LoginIn" },
  { code: 2, name: "共通", enumname: "Common" },
  { code: 3, name: "事業者情報", enumname: "Businessinfo" },
  { code: 4, name: "収集書類情報", enumname: "CollectedDocumentInfo" },
  { code: 5, name: "収集業務管理", enumname: "CollectionBusinessManagement" },
  { code: 6, name: "データ登録", enumname: "DataRegistration" },
  { code: 7, name: "ログ管理", enumname: "LogManagement" },
];

export const OBJECT_TYPE_LIST = [
  { code: 2, name: "事業者情報", enumname: "BusinessOperator" },
  { code: 4, name: "社員情報", enumname: "Employee" },
  { code: 1, name: "収集・配信情報", enumname: "TaxFiling" },
  { code: 3, name: "ファイル管理", enumname: "FileManage" },
];

export const OBJECT_TYPE_LIST_FILEMANAGE = [
	{ code: 2, name: '事業者情報', enumname: "BusinessOperator" },
	{ code: 3, name: 'ファイル管理', enumname: "FileManage" },
]

export const PROCESSING_DIVISION_LIST = [
  { code: 99, name: "指定しない", enumname: "All" },
  { code: 1, name: "新規作成", enumname: "CreateNew" },
  { code: 3, name: "保存", enumname: "Save" },
  { code: 4, name: "削除", enumname: "Delete" },
  { code: 2, name: "開く", enumname: "Open" },
  { code: 5, name: "移動", enumname: "Move" },
];

export const PROCESSING_DIVISION_LIST_LOGIN = [
  { code: 1, name: "ログイン", enumname: "Login" },
  { code: 2, name: "ログアウト", enumname: "LoginOut" },
];

export const PRESENT_SITUATION_LIST = [
  { code: 98, name: "指定しない" },
  { code: 0, name: "在職" },
  { code: 1, name: "退職" },
  { code: 2, name: "死亡退職" },
  { code: 3, name: "休職" },
];

export const PROCESSING_DIVISION_LIST_FILEMANAGE = [
	{ code: 99, name: '指定しない', enumname: "All" },
	{ code: 1, name: '新規作成', enumname: "CreateNew" },
	{ code: 3, name: '保存', enumname: "Save" },
	{ code: 4, name: '削除', enumname: "Delete" },
	{ code: 2, name: '開く', enumname: "Open" },
	{ code: 5, name: '移動', enumname: "Move" },
];
export const PAPERTYPE_LIST = [
	{ code: 0, name: '' },
	{ code: 1, name: '注文書' },
	{ code: 2, name: '契約書' },
	{ code: 3, name: '送り状' },
	{ code: 4, name: '領収書' },
	{ code: 5, name: '見積書' },
	{ code: 6, name: '請求書' },
	{ code: 7, name: 'その他' }
];

export const FUNCTION_USAGE_AUTHORITY_FOR_BOP_LIST = [
	{ code: 0, name: '許可' },
	{ code: 1, name: '拒否' }
];

export const ACCOUNT_STATUS_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "無効" },
  { code: 2, name: "有効" },
];
//収集方法
export const COLLECTION_METHOD_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "オンライン" },
  { code: 2, name: "書面" },
];
//メールアドレス設定
export const EMAIL_ADDRESS_SETTING_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "設定済" },
  { code: 100, name: "未設定" },
];
export const EMAIL_ADDRESS_ISSETTING_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "メールアドレスあり" },
  { code: 100, name: "メールアドレスなし" },
];
//退職日
export const RETIREMENT_DATE_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "指定日" },
  { code: 2, name: "指定日以前" },
  { code: 3, name: "指定日以降" },
  { code: 4, name: "指定月" },
  { code: 5, name: "指定期間" },
  { code: 6, name: "未設定" },
];
//アカウント通知
export const NOTIFICATION_LIST = [
  { code: 0, name: "アカウント未通知", enumname: "NotNotified" },
  { code: 1, name: "アカウント通知済", enumname: "Notified" },
];
//社員収集状況
export const EMPLOYEE_COLLECTION_STATUS_LIST = [
  { code: 99, name: "指定しない", enumname: "All" },
  { code: 1, name: "未収集", enumname: "Unrequested" },
  { code: 2, name: "依頼済", enumname: "Requested" },
  { code: 3, name: "収集済", enumname: "Collected" },
  { code: 4, name: "差戻し", enumname: "RollBack" },
  { code: 5, name: "確認済", enumname: "Checked" },
  { code: 6, name: "期限切れ", enumname: "Expired" },
  { code: 0, name: "収集状況なし", enumname: "None" },
];
//年末調整
export const YEAREND_ADJUSTMENT_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "する" },
  { code: 2, name: "しない" },
  { code: 3, name: "対象外" },
];
//提出期限
export const SUBMISSION_DEADLINE_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "指定日" },
  { code: 2, name: "指定月" },
  { code: 3, name: "指定期間" },
  { code: 4, name: "未設定" },
];
//チェック項目①,チェック項目②,チェック項目③
export const CHECK_ITEM_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "チェック有り" },
  { code: 2, name: "チェック無し" },
];
//扶養、配偶者等申告書収集状況,保険料控除申告書収集状況,住宅借入金等特別控除申告書収集状況
export const DEPENDENTS_SPOUSEETC_REPORT_COLLECTION_STATUS_LIST = [
  { code: 99, name: "指定しない", enumname: "All" },
  { code: 1, name: "準備中", enumname: "InPreparation" },
  { code: 2, name: "作成中", enumname: "Making" },
  { code: 3, name: "未確認", enumname: "UnChecked" },
  { code: 4, name: "指摘有", enumname: "PointedOut" },
  { code: 5, name: "確認済", enumname: "Checked" },
  { code: 0, name: "区分なし", enumname: "None" },
];

export const FUNCTION_USAGE_AUTHORITY_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "許可" },
  { code: 2, name: "拒否" },
];
export const FUNCTION_USAGE_AUTHORITY_LIST_NENCHO = [
  { code: 0, name: "指定しない" },
  { code: 100, name: "未設定" },
  { code: 1, name: "許可" },
  { code: 2, name: "拒否" },
];

//社員配信状況
export const DDISTRIBUTION_STATUS_LIST = [
  { code: 99, name: "指定しない", enumname: "All" },
  { code: 1, name: "未配信", enumname: "Undelivered" },
  { code: 2, name: "配信済", enumname: "Delivered" },
  { code: 3, name: "受取確認済", enumname: "ConfirmedReceipt" },
];

//社員配信状況-税額通知書配信情報
export const TAX_DISTRIBUTION_STATUS_LIST = [
  { code: 99, name: "指定しない", enumname: "All" },
  { code: 1, name: "未配信(未取り込み)", enumname: "NotImported" },
  { code: 2, name: "未配信(取り込み済)", enumname: "Imported" },
  { code: 3, name: "配信済", enumname: "Delivered" },
  { code: 4, name: "受取確認済", enumname: "ConfirmedReceipt" },
];

//配信年月日
export const DISTRIBUTION_DATE_LIST = [
  { code: 0, name: "指定しない" },
  { code: 2, name: "指定日" },
  { code: 3, name: "指定月" },
  { code: 1, name: "指定期間" },
  { code: 4, name: "未設定" },
];

//インポート状況
export const IMPORT_STATUS_LIST = [
  { code: 0, name: "指定しない" },
  { code: 2, name: "未インポート" },
  { code: 3, name: "インポート済" },
  { code: 1, name: "対象外" },
];

//インポート対象外
export const IMPORT_NOTAPPLICABLE_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "対象" },
  { code: 2, name: "対象外" },
];

//アカウントロック
export const ACCOUNT_LOCK_LIST = [
  { code: 0, name: "指定しない" },
  { code: 1, name: "ロック" },
  { code: 2, name: "-" },
];
export const FILTER_VIEWS_DISPLAY_FLAG_LIST = [
  {
		pageId: "STFMFM02C01",
		ClassificationControlBusinessInfo: true,
		//事業者情報
		DisplayFlagsBusiness: {
			title: true,
			BusinessCode: true,//事業者コード
			BusinessName: true,//事業者名
			CorporateIndividualClassification: true,//法人個人区分
			SettlementDate: true,//決算日
			MainCharge: true,//主担当者名
			BusinessAccount: true,//事業者アカウント
			//BusinessFunctionRelease: false,//事業者への機能開放
			BusinessNotificationDestination: true,//事業者からの通知先
		},
	},
  {
    pageId: "STDSDC02C01",
    ClassificationControlBusinessInfo: true,
    //事業者情報
    DisplayFlagsBusiness: {
      title: true,
      BusinessCode: true, //事業者コード
      BusinessName: true, //事業者名
      CorporateIndividualClassification: true, //法人個人区分
      SettlementDate: true, //決算日
      MainCharge: true, //主担当者名
      // BusinessAccount: true,//事業者アカウント
      //BusinessFunctionRelease: true, //事業者に対する機能利用権限
      //BusinessNotificationDestination: true,//事業者からの通知先
    },
  },
  {
    pageId: "STDSDC02C10",
    ClassificationControlMemberInfo: true,
    //社員情報
    DisplayFlagsMemberInfo: {
      title: "社員情報",
      BelongingCode: true, //所属コード
      Belonging: true, //所属
      EmployeeCode: true, //社員コード
      EmployeeName: true, //社員名
      EmployeeNameTitle: "社員名", //社員名
      CurrentSituation: true, //現況
      EmailAddress: true, //メールアドレス
      AccountStatus: true, //アカウント状態
      Notification: true, //メール通知
    },
  },
  {
    pageId: "STDSDC03C01",
    ClassificationControlBusinessInfo: true,
    ClassificationControlDeclarationInfo: true,
    //事業者情報
    DisplayFlagsBusiness: {
      title: true,
      BusinessCode: true, //事業者コード
      BusinessName: true, //事業者名
      CorporateIndividualClassification: true, //法人個人区分
      SettlementDate: true, //決算日
      MainCharge: true, //主担当者名
      // BusinessAccount: true,//事業者アカウント
      // BusinessFunctionRelease: true,//事業者に対する機能利用権限
      // BusinessNotificationDestination: true,//事業者からの通知先
    },
    //申告書等情報
    DisplayFlagsDeclaration: {
      title: true,
      DeclarationYear: true, //申告書等
      FiscalYearStart: true, //事業年度等（開始）
      FiscalYearEnd: true, //事業年度等（終了）
      DataPartition: true, //データ区分
      DataName: true, //データ名称
    },
  },
  {
    pageId: "STDSDC04C01",
    ClassificationControlBusinessInfo: true,
    ClassificationControlDeclarationInfo: true,
    //事業者情報
    DisplayFlagsBusiness: {
      title: true,
      BusinessCode: true, //事業者コード
      BusinessName: true, //事業者名
      CorporateIndividualClassification: true, //法人個人区分
      SettlementDate: true, //決算日
      MainCharge: true, //主担当者名
    },
    //申告書等情報
    DisplayFlagsDeclaration: {
      title: true,
      DeclarationYear: true, //申告書等
      FiscalYearStart: true, //事業年度等（開始）
      FiscalYearEnd: true, //事業年度等（終了）
      DataPartition: true, //データ区分
      DataName: true, //データ名称
      CollectedDocumentinfo: true, //書類収集状況
    },
  },
  {
    pageId: "STDSDC05C08",
    ClassificationControlAccessInfo: true,
    //ログイン履歴情報
    DisplayFlagsProcessing: {
      title: true,
      DC05C08Model: true,
      ProcessingDivisionList: [1, 2, 99], //処理区分
      titleName: "ログイン履歴情報",
      dateNameText: "操作日時",
      ProcessingTime: true, //処理日時
      //TreamTarget: true,//処理對象
      ProcessingPartition: true, //処理区分
      BopUser: true, //事業者情報
      LoginInID: true, //ログインID
      UserNameID: true, //利用者名ID
      IPIdress: true, //IPアドレス
    },
  },
  {
    pageId: "STDSDC05C09",
    ClassificationControlAccessInfo: true,
    //操作履歴情報
    DisplayFlagsProcessing: {
      title: true,
      DC05C09Model: true,
      ProcessingDivisionList: [1, 2, 3, 4, 5, 99], //処理区分
      titleName: "操作履歴情報",
      dateNameText: "処理日時",
      ProcessingTime: true, //処理日時
      TreamTarget: true, //処理對象
      ProcessingData: true, //処理データ
      ProcessingPartition: true, //処理区分
      LoginInID: true, //ログインID
      UserNameID: true, //利用者名ID
      IPIdress: true, //IPアドレス
    },
  },
  {
    pageId: "STDSDC03C03",
    ClassificationControlBusinessInfo: true,
    //事業者情報
    DisplayFlagsBusiness: {
      title: false,
      BusinessCode: true, //事業者コード
      BusinessName: true, //事業者名
      CorporateIndividualClassification: true, //法人個人区分
      SettlementDate: true, //決算日
      MainCharge: true, //主担当者名
      BusinessFunctionRelease: true, //事業者に対する機能利用権限
    },
  },
  {
    pageId: "STDSDR02C02",
    ClassificationControlMemberInfo: true,
    //社員情報
    DisplayFlagsMemberInfo: {
      title: "社員情報",
      BelongingCode: true, //所属コード
      Belonging: true, //所属
      EmployeeCode: true, //社員コード
      EmployeeName: true, //社員名
      EmployeeNameTitle: "社員名", //社員名
      CurrentSituation: true, //現況
      EmailAddress: true, //メールアドレス
      AccountStatus: true, //アカウント状態
      Notification: true, //メール通知
    },
  },
  {
    pageId: "STDSDR02C06",
    ClassificationControlMemberInfo: true,
    //年末調整対象社員一覧
    DisplayFlagsMemberInfo: {
      title: "年末調整対象社員一覧",
      BelongingCode: true, //所属コード
      Belonging: true, //所属
      EmployeeCode: true, //社員コード
      EmployeeName: true, //社員名
      EmployeeNameTitle: "社員名", //社員名
      CurrentSituation: true, //現況
      RetirementDate: true, //退職日
      EmailAddress: true, //メールアドレス
      CollectionMethod: true, //収集方法
      DeliveryMethod: true, //配信方法
    },
  },
  {
    pageId: "STDSDC03C12",
    ClassificationControlMemberInfo: true,
    //年末調整対象社員一覧
    DisplayFlagsMemberInfo: {
      title: "年末調整対象社員一覧",
      BelongingCode: true, //所属コード
      Belonging: true, //所属
      EmployeeCode: true, //社員コード
      EmployeeName: true, //社員名
      EmployeeNameTitle: "社員名", //社員名
      CurrentSituation: true, //現況
      RetirementDate: true, //退職日
      EmailAddress: true, //メールアドレス
      CollectionMethod: true, //収集方法
      DeliveryMethod: true, //配信方法
    },
  },
  {
    pageId: "STDSDR02C07",
    ClassificationControlMemberInfo: true,
    //年末調整対象社員情報取込
    DisplayFlagsMemberInfo: {
      title: "年末調整対象社員情報取込",
      BelongingCode: true, //所属コード
      Belonging: true, //所属
      EmployeeCode: true, //社員コード
      EmployeeName: true, //社員名
      EmployeeNameTitle: "社員名", //社員名
      CurrentSituation: true, //現況
      RetirementDate: true, //退職日
      EmailAddressSetting: true, //メールアドレス設定
    },
  },
  {
    pageId: "STDSDC03C13",
    ClassificationControlMemberInfo: true,
    //年末調整対象社員情報取込
    DisplayFlagsMemberInfo: {
      title: "年末調整対象社員情報取込",
      BelongingCode: true, //所属コード
      Belonging: true, //所属
      EmployeeCode: true, //社員コード
      EmployeeName: true, //社員名
      EmployeeNameTitle: "社員名", //社員名
      CurrentSituation: true, //現況
      RetirementDate: true, //退職日
      EmailAddressSetting: true, //メールアドレス設定
    },
  },
  {
    pageId: "STDSDR02C08",
    ClassificationControlMemberInfo: true,
    //社員の年末調整収集状況
    DisplayFlagsMemberInfo: {
      title: "社員の年末調整収集状況",
      EmployeeCollectionStatus: true,//社員収集状況
      CollectionMethodKubi: true, //収集方法
      BelongingCode: true, //所属コード
      Belonging: true, //所属
      EmployeeCode: true, //社員コード
      EmployeeName: true, //社員名
      EmployeeNameTitle: "社員名(フリガナ)", //社員名
      CurrentSituation: true, //現況
      YearEndAdjustment: true, //年末調整
      SubmissionDeadline: true, //提出期限
      DependentsSpouseEtcReportCollectionStatus: true, //扶養、配偶者等申告書収集状況
      CollectionOfInsurancePremiumDeductionForms: true, //保険料控除申告書収集状況
      CollectionStatusOfSpecialDeductionReportsForHousingLoans: true, //住宅借入金等特別控除申告書収集状況
      CheckItem1: true, //チェック項目①
      CheckItem2: true, //チェック項目②
      CheckItem3: true, //チェック項目③
    },
  },
  {
    pageId: "STDSDC04C07",
    ClassificationControlMemberInfo: true,
    //社員の年末調整収集状況
    DisplayFlagsMemberInfo: {
      title: "社員の年末調整収集状況",
      EmployeeCollectionStatus: true,//社員収集状況
      CollectionMethodKubi: true, //収集方法
      BelongingCode: true, //所属コード
      Belonging: true, //所属
      EmployeeCode: true, //社員コード
      EmployeeName: true, //社員名
      EmployeeNameTitle: "社員名(フリガナ)", //社員名
      CurrentSituation: true, //現況
      YearEndAdjustment: true, //年末調整
      SubmissionDeadline: true, //提出期限
      DependentsSpouseEtcReportCollectionStatus: true, //扶養、配偶者等申告書収集状況
      CollectionOfInsurancePremiumDeductionForms: true, //保険料控除申告書収集状況
      CollectionStatusOfSpecialDeductionReportsForHousingLoans: true, //住宅借入金等特別控除申告書収集状況
      CheckItem1: true, //チェック項目①
      CheckItem2: true, //チェック項目②
      CheckItem3: true, //チェック項目③
    },
  },

	{
		pageId: "STFMFM02C11",
		// 絞り込み条件(ファイル一覧_電子取引・スキャナ保存)
		DisplayFlags: {
			title: true,
			searchTaget: true,
			searchTagetSeparator: true,
			keyWord: true,
			dealinginfoInputStatus: true,
			fileName: true,
			paperID: true,  // No4:スキャナ保存対応 書類ID
			paperType: true,
			issueDate: true,
			company: true,
			amount: true,
			remarks: true,
			updater: true,
		},
		DisplayItems: {
			title: "検索対象、検索条件を設定してください。\n※フォルダは検索されません。",
			searchTaget: "検索対象",
			keyWord: "検索キーワード",
			dealinginfoInputStatus: "取引情報登録状況",
			fileName: "名称",
			paperID: "書類ID",  // No4:スキャナ保存対応 書類ID
			paperType: "書類種別",
			issueDate: "取引年月日",
			company: "取引先",
			amount: "取引金額",
			remarks: "備考",
			updater: "保存者",
		},
	},
	{
		pageId: "STFMFM02C12",
		// 絞り込み条件(ファイル一覧_電子取引_時系列表示)
		DisplayFlags: {
			title: true,
			searchTaget: false,
			keyWord: true,
			dealinginfoInputStatus: true,
			fileName: true,
			paperID: true,  // No4:スキャナ保存対応 書類ID
			paperType: true,
			issueDate: true,
			company: true,
			amount: true,
			remarks: true,
			updater: true,
		},
		DisplayItems: {
			title: "検索条件を設定してください。",
			searchTaget: "検索対象",
			keyWord: "検索キーワード",
			dealinginfoInputStatus: "取引情報登録状況",
			fileName: "名称",
			paperID: "書類ID",  // No4:スキャナ保存対応 書類ID
			paperType: "書類種別",
			issueDate: "取引年月日",
			company: "取引先",
			amount: "取引金額",
			remarks: "備考",
			updater: "保存者",
		},
	},
];
// **********************************************
//機能利用権限
// **********************************************
export const FUNCTION_AUTHORITY_LIST = [
	{ code: 0, name: "事業者情報【追加/更新/削除】", serviceKeyName: 'FuBopBopInfo', },
	{ code: 0, name: "フォルダ・ファイルの操作【作成/編集/削除/移動/複写】", serviceKeyName: 'FuTfmFolderOperation', },
	{ code: 0, name: "ファイルの操作【登録/編集/削除/移動/複写】", serviceKeyName: 'FuTfmFileOperation', },
];
// 絞り込み条件(ファイル一覧)
// 検索対象
export const SEARCH_TARGET_CODE_LIST = [
	{ code: "0", name: 'すべてのフォルダ' },
	{ code: "1", name: '現在のフォルダ' },
	{ code: "2", name: '現在のフォルダ以下' },
];

// 取引情報登録状況
export const DEALINGINFO_INPUT_STATUS_CODE_LIST = [
	{ code: "0", name: '指定しない' },
	{ code: "1", name: '未完了' },
	{ code: "2", name: '完了' },
];
// 名称
export const FILE_NAME_CODE_LIST = [
	{ code: "0", name: '指定しない' },
	{ code: "1", name: '次のキーワードを含む' },
	{ code: "2", name: '次のキーワードを含まない' },
];
// No4:スキャナ保存対応 書類ID start
// 書類ID
export const PAPER_ID_CODE_LIST = [
	{ code: "0", name: '指定しない' },
	{ code: "1", name: '次のキーワードを含む' },
	{ code: "2", name: '次のキーワードを含まない' },
];  // No4:スキャナ保存対応 書類ID end
// 書類種別
export const PAPER_TYPE_CODE_LIST = [
	{ code: "0", name: '指定しない' },
	{ code: "1", name: '注文書' },
	{ code: "2", name: '契約書' },
	{ code: "3", name: '送り状' },
	{ code: "4", name: '領収書' },
	{ code: "5", name: '見積書' },
	{ code: "6", name: '請求書' },
	{ code: "7", name: 'その他' },
	{ code: "8", name: '次のキーワードを含む' },
	{ code: "9", name: '次のキーワードを含まない' },
	{ code: "10", name: '未設定' },
];
// 取引年月日
export const ISSUE_DATE_CODE_LIST = [
	{ code: "0", name: '指定しない' },
	{ code: "1", name: '指定日' },
	{ code: "2", name: '指定日以前' },
	{ code: "3", name: '指定日以降' },
	{ code: "4", name: '指定月' },
	{ code: "5", name: '指定期間' },
];
// 取引先
export const COMPANY_CODE_LIST = [
	{ code: "0", name: '指定しない' },
	{ code: "1", name: '次のキーワードを含む' },
	{ code: "2", name: '次のキーワードを含まない' },
	{ code: "3", name: '未設定' },
];
// 取引金額
//
export const AMOUNT_CODE_LIST = [
	{ code: "0", name: '指定しない' },
	{ code: "1", name: '指定金額' },
	{ code: "2", name: '指定金額以下' },
	{ code: "3", name: '指定金額以上' },
	{ code: "4", name: '指定範囲' },
];
// 備考
export const REMARKS_CODE_LIST = [
	{ code: "0", name: '指定しない' },
	{ code: "1", name: '次のキーワードを含む' },
	{ code: "2", name: '次のキーワードを含まない' },
	{ code: "3", name: '未設定' },
];
// 更新者
export const UPDATER_CODE_LIST = [
	{ code: "0", name: '指定しない' },
	{ code: "1", name: '次のキーワードを含む' },
	{ code: "2", name: '次のキーワードを含まない' },
];
// 検索対象
export const SearchTargetCodeValue = {
	AllFolder:"0",				//すべてのフォルダ
	CurrentFolder:"1",			//現在のフォルダ
	UnderCurrentFolder:"2",		//現在のフォルダ以下
};
// 取引情報登録状況
export const DealinginfoInputStatusCodeValue = {
	All:"0",					//設定しない
	Unfinished:"1",				//未完了
	Finished:"2",				//完了
};
// 名称
export const FileNameCodeValue = {
	All:"0",					//指定しない
	Include:"1",				//次のキーワードを含む
	Exclude:"2",				//次のキーワードを含まない
};

// No4:スキャナ保存対応 書類ID start
// 書類ID
export const PaperIdCodeValue = {
	All:"0",					//指定しない
	Include:"1",				//次のキーワードを含む
	Exclude:"2",				//次のキーワードを含まない
};  // No4:スキャナ保存対応 書類ID end

// 書類種別
export const PaperTypeCodeValue = {
	All:"0",					//指定しない
	PurchaseOrder:"1",		//注文書
	Contract:"2",				//契約書
	Invoice:"3",				//送り状
	Receipt:"4",				//領収書
	Quotation:"5",				//見積書
	Bill:"6",					//請求書
	Other:"7",					//その他
	Include:"8",				//次のキーワードを含む
	Exclude:"9",				//次のキーワードを含まない
	NotEntered:"10",			//未設定
};
// 取引年月日
export const IssueDateCodeValue = {
	All:"0",					//指定しない
	SpecifiedDay:"1",			//指定日
	BeforeSpecifiedDay:"2",		//指定日以前
	AfterSpecifiedDay:"3",		//指定日以降
	SpecifiedMonth:"4",			//指定月
	DuringDate:"5",				//指定期間
};
// 取引先
export const CompanyCodeValue = {
	All:"0",					//指定しない
	Include:"1",				//次のキーワードを含む
	Exclude:"2",				//次のキーワードを含まない
	NotEntered:"3",				//未設定
};
// 取引金額
export const AmountCodeValue = {
	All:"0",					//指定しない
	SpecifiedAmount:"1",		//指定金額
	LessSpecifiedAmount:"2",	//指定金額以下
	MoreSpecifiedAmount:"3",	//指定金額以上
	DuringAmount:"4",			//指定範囲
};
// 備考
export const RemarksCodeValue = {
	All:"0",					//指定しない
	Include:"1",				//次のキーワードを含む
	Exclude:"2",				//次のキーワードを含まない
	NotEntered:"3",				//未設定
};
// 更新者
export const UpdaterCodeValue = {
	All:"0",					//指定しない
	Include:"1",				//次のキーワードを含む
	Exclude:"2",				//次のキーワードを含まない
};
export const GengoCodeValue = {
	Reiwa:"0",
	Heisei:"1",
};

//#endregion

// **********************************************
//　都道府県
// **********************************************
export const PREFECTURE_DATA = [
  {
    code: "01",
    name: "北海道",
    nameF: "ほっかいどう",
  },
  {
    code: "02",
    name: "青森県",
    nameF: "あおもりけん",
  },
  {
    code: "03",
    name: "岩手県",
    nameF: "いわてけん",
  },
  {
    code: "04",
    name: "宮城県",
    nameF: "みやぎけん",
  },
  {
    code: "05",
    name: "秋田県",
    nameF: "あきたけん",
  },
  {
    code: "06",
    name: "山形県",
    nameF: "やまがたけん",
  },
  {
    code: "07",
    name: "福島県",
    nameF: "ふくしまけん",
  },
  {
    code: "08",
    name: "茨城県",
    nameF: "いばらきけん",
  },
  {
    code: "09",
    name: "栃木県",
    nameF: "とちぎけん",
  },
  {
    code: "10",
    name: "群馬県",
    nameF: "ぐんまけん",
  },
  {
    code: "11",
    name: "埼玉県",
    nameF: "さいたまけん",
  },
  {
    code: "12",
    name: "千葉県",
    nameF: "ちばけん",
  },
  {
    code: "13",
    name: "東京都",
    nameF: "とうきょうと",
  },
  {
    code: "14",
    name: "神奈川県",
    nameF: "かながわけん",
  },
  {
    code: "15",
    name: "新潟県",
    nameF: "にいがたけん",
  },
  {
    code: "16",
    name: "富山県",
    nameF: "とやまけん",
  },
  {
    code: "17",
    name: "石川県",
    nameF: "いしかわけん",
  },
  {
    code: "18",
    name: "福井県",
    nameF: "ふくいけん",
  },
  {
    code: "19",
    name: "山梨県",
    nameF: "やまなしけん",
  },
  {
    code: "20",
    name: "長野県",
    nameF: "ながのけん",
  },
  {
    code: "21",
    name: "岐阜県",
    nameF: "ぎふけん",
  },
  {
    code: "22",
    name: "静岡県",
    nameF: "しずおかけん",
  },
  {
    code: "23",
    name: "愛知県",
    nameF: "あいちけん",
  },
  {
    code: "24",
    name: "三重県",
    nameF: "みえけん",
  },
  {
    code: "25",
    name: "滋賀県",
    nameF: "しがけん",
  },
  {
    code: "26",
    name: "京都府",
    nameF: "きょうとふ",
  },
  {
    code: "27",
    name: "大阪府",
    nameF: "おおさかふ",
  },
  {
    code: "28",
    name: "兵庫県",
    nameF: "ひょうごけん",
  },
  {
    code: "29",
    name: "奈良県",
    nameF: "ならけん",
  },
  {
    code: "30",
    name: "和歌山県",
    nameF: "わかやまけん",
  },
  {
    code: "31",
    name: "鳥取県",
    nameF: "とっとりけん",
  },
  {
    code: "32",
    name: "島根県",
    nameF: "しまねけん",
  },
  {
    code: "33",
    name: "岡山県",
    nameF: "おかやまけん",
  },
  {
    code: "34",
    name: "広島県",
    nameF: "ひろしまけん",
  },
  {
    code: "35",
    name: "山口県",
    nameF: "やまぐちけん",
  },
  {
    code: "36",
    name: "徳島県",
    nameF: "とくしまけん",
  },
  {
    code: "37",
    name: "香川県",
    nameF: "かがわけん",
  },
  {
    code: "38",
    name: "愛媛県",
    nameF: "えひめけん",
  },
  {
    code: "39",
    name: "高知県",
    nameF: "こうちけん",
  },
  {
    code: "40",
    name: "福岡県",
    nameF: "ふくおかけん",
  },
  {
    code: "41",
    name: "佐賀県",
    nameF: "さがけん",
  },
  {
    code: "42",
    name: "長崎県",
    nameF: "ながさきけん",
  },
  {
    code: "43",
    name: "熊本県",
    nameF: "くまもとけん",
  },
  {
    code: "44",
    name: "大分県",
    nameF: "おおいたけん",
  },
  {
    code: "45",
    name: "宮崎県",
    nameF: "みやざきけん",
  },
  {
    code: "46",
    name: "鹿児島県",
    nameF: "かごしまけん",
  },
  {
    code: "47",
    name: "沖縄県",
    nameF: "おきなわけん",
  },
  
];

export const KINYU_CODE_LIST = [
  "9999",
  "8888",
  "9977",
  "7777"
];

export const COLLECT_DATA_TYPE = [
  { code: 2, name: "社員に対する年末調整機能", enumname: "Nencho" },
  { code: 1, name: "事業者に対する書類収集機能", enumname: "Document" },
  { code: 3, name: "全ての機能(年末調整、書類収集)", enumname: "All" },
];

// サイインアプリケーション文字列
// 事業者
export const SIGNINAPPLICATION_BOP = "Bop";
// 税理士年末調整
export const SIGNINAPPLICATION_DATACOLLECTION_NENCHO = "DataCollection_Nencho";// 集配信 
export const SIGNINAPPLICATION_DATACOLLECTION = "DataCollection";
// 年末調整
export const SIGNINAPPLICATION_NENCHO = "Nencho";
// 電帳法 
export const SIGNINAPPLICATION_FILEMANAGE = "FileManage";
export const PDFSIZERANGE = [25, 33, 50, 67, 75, 80, 90, 100, 110, 125, 150, 175, 200];